module.exports = __webpack_public_path__ + "img/chevron-right-red.cf3c4c84.svg";